<template lang="pug">
    .ma-sm-2(v-if="validOrganizationID")

        .text-center(v-if="isLoading || enrollmentLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        div(v-else)
            v-card.mx-auto.mb-sm-4(
                outlined
            )
                template
                    v-list(two-line)
                        template(v-if="validSwitchCustomer")
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-office-building
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='12')
                                                v-autocomplete(
                                                    :items='organizationUsers'
                                                    item-text='organization_name'
                                                    item-value='organization_id'
                                                    label='Organization'
                                                    v-model='overrideOrganizationId'
                                                )

                        template
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-account
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='6')
                                                v-text-field(label='First Name' type='text' v-model="firstName" @keydown.enter="handleEnterEvent()")
                                            v-col.py-2(cols='6')
                                                v-text-field(label='Last Name' type='text' v-model="lastName" @keydown.enter="handleEnterEvent()")

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-phone
                                v-list-item-content
                                    v-list-item-title
                                        v-row(align="center")
                                            v-col.py-2(cols='6')
                                                v-select(
                                                    :items='countries'
                                                    :item-text="pnCountryDisplay"
                                                    item-value="iso_two"
                                                    label='Country'
                                                    v-model="cpnCountryIsoTwo"
                                                )
                                            v-col.py-2(cols='6')
                                                v-text-field(
                                                    label='Cell Phone'
                                                    type='text'
                                                    v-model="cellPhone"
                                                    v-on:keypress="phoneNumberChange"
                                                    @keydown.enter="handleEnterEvent()"
                                                )
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title
                                        v-row(align="center")
                                            v-col.py-2(cols='6')
                                                v-select(
                                                    :items='countries'
                                                    :item-text="pnCountryDisplay"
                                                    item-value="iso_two"
                                                    label='Country'
                                                    v-model="hpnCountryIsoTwo"
                                                )
                                            v-col.py-2(cols='6')
                                                v-text-field(
                                                    label='Home Phone'
                                                    type='text'
                                                    v-model="homePhone"
                                                    v-on:keypress="phoneNumberChange"
                                                    @keydown.enter="handleEnterEvent()"
                                                )
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title
                                        v-row(align="center")
                                            v-col.py-2(cols='6')
                                                v-select(
                                                    :items='countries'
                                                    :item-text="pnCountryDisplay"
                                                    item-value="iso_two"
                                                    label='Country'
                                                    v-model="wpnCountryIsoTwo"
                                                )
                                            v-col.py-2(cols='6')
                                                v-text-field(
                                                    label='Work Phone'
                                                    type='text'
                                                    v-model="workPhone"
                                                    v-on:keypress="phoneNumberChange"
                                                    @keydown.enter="handleEnterEvent()"
                                                )

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-email
                                v-list-item-content
                                    v-list-item-title
                                        v-row(align="center")
                                            v-col.py-2(cols='12')
                                                v-text-field(
                                                    label='Email Address'
                                                    type='text'
                                                    v-model="emailAddress"
                                                    @keydown.enter="handleEnterEvent()"
                                                )

                        //- todo - update city & regions to dropdown for us/canada to match form_dialog for customer_addresses
                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-map-marker
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='6')
                                                v-text-field(label='Street One' type='text' v-model="addressStreetOne" @keydown.enter="handleEnterEvent()")
                                            v-col.py-2(cols='6')
                                                v-text-field(label='Street Two' type='text' v-model="addressStreetTwo" @keydown.enter="handleEnterEvent()")
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='6')
                                                v-text-field(label='City' type='text' v-model="addressCity" @keydown.enter="handleEnterEvent()")
                                            v-col.py-2(cols='6')
                                                v-text-field(label='Region' type='text' v-model="addressRegion" @keydown.enter="handleEnterEvent()")
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='6')
                                                v-text-field(label='Postal Code' type='text' v-model="addressPostalCode"  @keydown.enter="handleEnterEvent()")
                                            v-col.py-2(cols='6')
                                                v-select(
                                                    :items='countries'
                                                    item-text="iso_two"
                                                    item-value="iso_two"
                                                    label='Country'
                                                    v-model="addressCountryIsoTwo"
                                                )

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-car
                                v-list-item-content
                                    v-list-item-title
                                        v-row
                                            v-col.py-2(cols='12')
                                                v-text-field(
                                                    label='Vehicle VIN' 
                                                    type='text' 
                                                    v-model="vehicleVin" 
                                                    @keydown.enter="handleEnterEvent()" 
                                                    :rules="[rules.vin]"
                                                    validate-on-blur
                                                )

                        template
                            v-divider(inset)
                            v-list-item
                                v-list-item-content
                                    v-row(align="center")
                                        v-col(cols='12')
                                            .text-right
                                                v-btn.mr-4(
                                                    v-if="validSwitchCustomer"
                                                    color="warning"
                                                    @click='cancelSwitchCustomer();'
                                                )
                                                    v-icon mdi-cancel
                                                    | Cancel Switch Customer
                                                v-btn.mr-4(
                                                    @click='reset();'
                                                )
                                                    v-icon mdi-refresh
                                                    | Reset
                                                v-btn.mr-4(
                                                    color='success'
                                                    @click='matchOrCreateCustomer();'
                                                    :disabled="createButtonDisabled"
                                                )
                                                    v-icon mdi-plus
                                                    | Create

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Data
    import { MatchOrCreateCustomer } from "@/data";

    // Helpers
    import { cleanupEmailAddress } from "@/helpers/email";
    import { cleanupPhoneNumber } from "@/helpers/phone_number";
    import { rules } from "@/helpers/input_validation";

    export default Vue.extend({
        data() {
            return {
                addressCity: null,
                addressCountryIsoTwo: "US",
                addressPostalCode: null,
                addressRegion: null,
                addressStreetOne: null,
                addressStreetTwo: null,
                cellPhone: null,
                cpnCountryIsoTwo: "US",
                emailAddress: null,
                firstName: null,
                homePhone: null,
                hpnCountryIsoTwo: "US",
                isLoading: false,
                lastName: null,
                middleName: null,
                overrideOrganizationId: null,
                rules,
                vehicleVin: null,
                workPhone: null,
                wpnCountryIsoTwo: "US",
            }
        },
        methods: {
            cleanPhoneNumber(phoneNumber, countryIsoTwo) {
                if (phoneNumber?.length > 0) {

                    // Validate
                    const cleaned = cleanupPhoneNumber(phoneNumber, countryIsoTwo);
                    if (cleaned?.valid === true) {
                        return cleaned.phoneNumber;
                    }
                }

                return "";
            },
            handleEnterEvent() {
                if(this.createButtonDisabled) {
                    return
                }

                this.matchOrCreateCustomer()
            },
            init() {

                // Initial: cell phone
                if (this.initialCellPhone?.length > 0) {
                        
                    // Validate
                    const cleaned = cleanupPhoneNumber(this.initialCellPhone, "");
                    if (cleaned?.valid === true) {
                        
                        // Set
                        this.cellPhone = cleaned.phoneNumber.replace(cleaned.dialingCode, "");
                        this.cpnCountryIsoTwo = cleaned.countryIso;
                    }
                }

                // Initial:
                this.firstName = this.initialFirstName?.length > 0 ? this.initialFirstName : null;
                this.emailAddress = this.initialEmailAddress?.length > 0 ? this.initialEmailAddress : null;
                this.lastName = this.initialLastName?.length > 0 ? this.initialLastName : null;

                // address
                if (this.initialAddress?.address_id > 0) {
                    this.addressCity = this.initialAddress.address_city;
                    this.addressCountryIsoTwo = this.initialAddress.address_country_iso_two;
                    this.addressPostalCode = this.initialAddress.address_postal_code;
                    this.addressRegion = this.initialAddress.address_region;
                    this.addressStreetOne = this.initialAddress.address_street_one;
                    this.addressStreetTwo = this.initialAddress.address_street_two;
                }
            },
            matchOrCreateCustomer() {
                // Init
                const options = {
                    address_city: this.addressCity,
                    address_country: this.addressCountryIsoTwo,
                    address_postal_code: this.addressPostalCode,
                    address_region: this.addressRegion,
                    address_street_one: this.addressStreetOne,
                    address_street_two: this.addressStreetTwo,
                    cell_phone: this.cleanCellPhone,
                    email_address: this.cleanEmailAddress,
                    first_name: this.firstName,
                    home_phone: this.cleanHomePhone,
                    last_name: this.lastName,
                    middle_name: this.middleName,
                    organization_id: (this.organizationId || 0),
                    sourceable_type: this.sourceableType,
                    vehicle_vin: this.vehicleVin,
                    work_phone: this.cleanWorkPhone,
                }

                // if we are rendering organization select, then use override
                if (this.validSwitchCustomer && this.overrideOrganizationId > 0) {
                    options.organization_id = this.overrideOrganizationId;
                }

                this.isLoading = true;
                MatchOrCreateCustomer(options).then((response) => {
                    if (response?.Data?.customer?.customer_id > 0) {
                        if (this.sourceableType === 'CommunicationCenter') {
                            if (this.validSwitchCustomer) {
                                this.switchCustomerForCampaignCustomerActive(response.Data.customer.customer_id);
                            } else {
                                this.enrollCampaignCustomer(response.Data.customer.customer_id, {});
                            }
                        } else {
                            this.$emit('select-customer', response.Data.customer);
                            const customerName = `${response.Data.customer.first_name} ${response.Data.customer.last_name}`.trim();
                            this.showSnackbar('success', `Successfully created customer: ${customerName}`);
                        }
                    } else if (this.sourceableType === 'AppointmentDashboard') {
                        this.showSnackbar('error', 'Failed to create customer');
                    }

                    this.isLoading = false;
                });
            },
            pnCountryDisplay(item) {
                return item?.iso_two + ' (' + item?.dialing_code + ")";
            },
            phoneNumberChange(e) {
                
                // Ensure only numbers are entered
                if (isNaN(e.key)) {
                    e.preventDefault();
                }
            },
            reset() {
                this.addressCity = null;
                this.addressCountryIsoTwo = "US";
                this.addressPostalCode = null;
                this.addressRegion = null;
                this.addressStreetOne = null;
                this.addressStreetTwo = null;
                this.cellPhone = null;
                this.cpnCountryIsoTwo = "US";
                this.emailAddress = null;
                this.firstName = null;
                this.homePhone = null;
                this.hpnCountryIsoTwo = "US";
                this.isLoading = false;
                this.lastName = null;
                this.middleName = null;
                this.vehicleVin = null;
                this.workPhone = null;
                this.wpnCountryIsoTwo = "US";
            },
        },
        computed: {
            callIsInbound() {
                return this.call?.id > 0 && this.call?.direction === "inbound";
            },
            cleanCellPhone() {
                return this.cleanPhoneNumber(this.cellPhone, this.cpnCountryIsoTwo);
            },
            cleanEmailAddress() {
                return cleanupEmailAddress(this.emailAddress);
            },
            cleanHomePhone() {
                return this.cleanPhoneNumber(this.homePhone, this.hpnCountryIsoTwo);
            },
            cleanWorkPhone() {
                return this.cleanPhoneNumber(this.workPhone, this.wpnCountryIsoTwo);
            },
            countries() {
                return VolieState.countries();
            },
            validVin() {
                return this.rules.vin(this.vehicleVin) === true;
            },
            createButtonDisabled() {

                if (this.isSupervisor && !this.isLiveDashInboundCall) {
                    return true;
                }

                // Clean up names
                const firstName = (this.firstName || "").trim();
                const lastName = (this.lastName || "").trim();

                // First or last name MUST be present
                if (firstName === "" && lastName === "") {
                    return true;
                }

                // Init
                const emailAddress = this.cleanEmailAddress;
                const cpn = this.cleanCellPhone;
                const hpn = this.cleanHomePhone;
                const wpn = this.cleanWorkPhone;

                switch(this.communicationType) {
                case "Email":
                    
                    // Email MUST have a valid email address
                    if (emailAddress === "") {
                        return true;
                    }

                    break;

                case "Phone":

                    // Phone MUST have at least one phone number
                    if (cpn === "" && hpn === "" && wpn === "") {
                        return true;
                    }

                    break;

                case "SMS Message":

                    // Sms message MUST have at least one phone number
                    if (cpn === "" && hpn === "" && wpn === "") {
                        return true;
                    }

                    break;
                }

                if (this.vehicleVin?.length > 0) {
                    return !this.validVin;
                }

                return false;
            },
            validCancelSwitchCustomer() {
                return this.cancelSwitchCustomer !== undefined && this.cancelSwitchCustomer !== null;
            },
            validOrganizationID() {
                return (this.organizationId > 0);
            },
            validOrganizationUsers() {
                return this.organizationUsers?.length > 0;
            },
            validSwitchCustomer() {
                return this.validOrganizationUsers && this.validCancelSwitchCustomer && this.switchCustomerForCampaignCustomerActive !== undefined && this.switchCustomerForCampaignCustomerActive !== null && (this.isSwitchingCustomer || this.callIsInbound);
            },
        },
        components: {
        },
        props: {
            call: Object,
            cancelSwitchCustomer: Function,
            communicationType: String,
            enrollCampaignCustomer: Function,
            enrollmentLoading: Boolean,
            initialAddress: Object,
            initialCellPhone: String,
            initialEmailAddress: String,
            initialFirstName: String,
            initialLastName: String,
            isSupervisor: Boolean,
            isLiveDashInboundCall: Boolean,
            isSwitchingCustomer: Boolean,
            organizationId: Number,
            organizationUsers: Array,
            showSnackbar: {
                type: Function,
                required: false
            },
            sourceableType: {
                type: String,
                default: 'CommunicationCenter',
                required: false,
            },
            switchCustomerForCampaignCustomerActive: Function,
        },
        destroyed() {
        },
        created() {
            this.overrideOrganizationId = this.organizationId;
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>
